import clsx from 'clsx';

import PropTypes from 'prop-types';

const TableBody = ({ getTableBodyProps, rows, prepareRow }) => {
    return (
        <tbody
            className="divide-y-2 divide-white dark:divide-icoDarkMode-anthracite"
            {...getTableBodyProps()}>
            {rows?.map((row, index) => {
                prepareRow(row);
                return (
                    <tr
                        {...row?.getRowProps()}
                        className="bg-icoGray-100 dark:bg-icoDarkMode-deepBlack"
                        key={index}>
                        {row?.cells?.map((cell, index) => (
                            <td
                                {...cell?.getCellProps({})}
                                key={index}
                                className={clsx('px-3 py-2', {
                                    'sticky right-0 z-2 bg-icoGray-100 before:absolute before:bottom-full before:left-0 before:h-0.5 before:w-full before:bg-white after:absolute after:left-0 after:top-0 after:h-full after:w-0.5 after:bg-white dark:bg-icoDarkMode-deepBlack dark:before:bg-icoDarkMode-anthracite after:dark:bg-icoDarkMode-anthracite':
                                        cell?.column?.id === 'download' ||
                                        cell?.column?.id === 'edit'
                                })}>
                                {cell?.column?.Cell?.name === 'defaultRenderer' ? (
                                    <span className="block truncate font-GMedium text-sm font-medium -tracking-wider text-icoGray-500 dark:text-icoDarkMode-wolf">
                                        {cell?.render('Cell')}
                                    </span>
                                ) : (
                                    cell?.render('Cell')
                                )}
                            </td>
                        ))}
                    </tr>
                );
            })}
        </tbody>
    );
};

TableBody.propTypes = {
    getTableBodyProps: PropTypes.func,
    prepareRow: PropTypes.func,
    rows: PropTypes.array
};

export default TableBody;
